import { Alert, Button, Modal } from "react-bootstrap"
import { LoadingIcon } from "../../Loading";

type OverwriteModalProps = {
    show: boolean;
    docname: string;
    isLoading: boolean;
    handleOverwrite: () => void;
    handleCancel: () => void;
}

const OverwriteModal = ({
    show,
    docname,
    isLoading,
    handleOverwrite,
    handleCancel,
}: OverwriteModalProps) => {
    return (
        <Modal centered show={show}>
            <Modal.Header>
                <Modal.Title>Confirm Uploading New File</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{display: 'inline'}}>
                {isLoading ?
                    <LoadingIcon showMsg={true} extraMsg={`Uploading document`} inline={true} />
                    :
                        <>
                            Document <b>{docname}</b> already exists, would you like to replace it? <br /><br />
                            <Alert variant="warning">This will replace the previous document content.</Alert>
                        </>
                }
            </Modal.Body>
            <Modal.Footer>
                {!isLoading &&
                    <>
                        <Button variant="text" onClick={(e) => {handleCancel()}}>Cancel</Button>
                        <Button variant="primary" onClick={(e) => {handleOverwrite()}}>Confirm</Button>
                    </>
                }
            </Modal.Footer>
        </Modal>
    );
}

export default OverwriteModal;